var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',[_c('main-menu')],1),_c('el-main',[_c('div',{staticClass:"content-box",attrs:{"id":"comtent-box"}},[_c('router-view')],1)]),_c('el-footer',{attrs:{"height":"20px"}},[_vm._v("powered by Vue")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }